import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { AppRemixIcon, AppMultiSelect } from "@/layout/AppComponents";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import ReactDOMServer from "react-dom/server";
import * as currentPageAction from "../../../../../store/actions/currentPageAction";
import Translator from "../../../../components/helpers/Translator";
import { axiosPath, path } from "../../../../../routing/helpers/router";
import { getEnvironmentalAspectsAssessmentInspectionFilterInitialValues } from "../../../../../minions/forms";
import AuxSidebar from "../../../../Sidebar/AuxSidebar";
import useIsMounted from "../../../../components/hooks/useIsMounted";
import { getEvaluationOptions } from "../tools/environmentalAspectsAssessmentTools";

export default function FilterSidebarBlock() {
  const { moduleBridgeHex, plantHex, assessmentHex, filtersHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const auxSidebar = useSelector((state) => state.currentPage?.auxSidebar?.opened);
  const filters = useSelector((state) => state.currentPage?.filters);
  const [openOnce, setOpenOnce] = useState(true);
  const periodicityOptions = useSelector(
    (state) => state.currentPage?.periodicityOptions,
  );
  const responsibleOptions = useSelector(
    (state) => state.currentPage?.responsibleOptions,
  );

  const handleAuxSidebar = () => {
    if (!openOnce) setOpenOnce(true);
    if (auxSidebar !== "filters")
      dispatch(currentPageAction.change("auxSidebar", { opened: "filters" }));
    else dispatch(currentPageAction.change("auxSidebar", { opened: null }));
  };

  const goToInspection = (hexCode) =>
    navigate(
      path({
        name: "user_module_environmentalAspectsAssessment_inspection_home",
        params: {
          moduleBridgeHex,
          plantHex,
          assessmentHex,
          filtersHex: hexCode,
        },
      }),
    );

  // > GENERATE FILTER HEX CODE
  const generateFilterHexCode = async (values, setSubmitting) =>
    axios
      .post(
        axiosPath(
          "api_r_user_module_environmentalAspectsAssessment_generateFilterHexCode",
        ),
        { moduleBridgeHex, filters: values },
      )
      .then(({ data }) => {
        setSubmitting(false);
        goToInspection(data.hexCode);
        dispatch(currentPageAction.change("auxSidebar", { opened: null }));
      });

  const handleOnSubmit = (values, { setSubmitting }) => {
    generateFilterHexCode(values, setSubmitting);
  };
  // < GENERATE FILTER HEX CODE

  // > FILTERS
  const getFilters = useCallback(
    async () =>
      axios
        .post(
          axiosPath("api_r_user_module_environmentalAspectsAssessment_getFilters"),
          {
            moduleBridgeHex,
            filtersHex,
          },
        )
        .then(({ data }) => {
          if (isMounted.current) {
            dispatch(
              currentPageAction.change("filters", {
                ...getEnvironmentalAspectsAssessmentInspectionFilterInitialValues(),
                ...data,
              }),
            );
          }
        }),
    [moduleBridgeHex, filtersHex],
  );

  useEffect(() => {
    if (filtersHex !== "0") {
      getFilters();
    } else {
      dispatch(
        currentPageAction.change(
          "filters",
          getEnvironmentalAspectsAssessmentInspectionFilterInitialValues(),
          true,
        ),
      );
    }
  }, [filtersHex]);
  // < FILTERS

  return (
    <>
      <li
        className={auxSidebar && auxSidebar === "filters" ? "active" : ""}
        onClick={() => handleAuxSidebar()}
      >
        <span className="sidebar-element">
          <AppRemixIcon icon="equalizer" className="sidebar-icon" />{" "}
          <span className="sb-title">
            <Translator file="module-legalCompliance" name="filtering" />
          </span>
        </span>
      </li>
      <AuxSidebar
        title={<Translator file="module-legalCompliance" name="filtering" />}
        isOpen={auxSidebar && auxSidebar === "filters"}
        width="350px"
        position="right"
        onClose={handleAuxSidebar}
      >
        {openOnce && (
          <>
            {filters && (
              <Formik
                validateOnChange={false}
                validateOnBlur={false}
                enableReinitialize
                initialValues={filters}
                onSubmit={handleOnSubmit}
              >
                {({
                  setFieldValue,
                  handleSubmit,
                  values,
                  errors,
                  isSubmitting,
                  resetForm,
                }) => (
                  <>
                    <div className="d-flex mt-3 mb-3">
                      <span
                        className="btn btn-info btn-block"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                      >
                        <Translator file="module-legalCompliance" name="filtering" />
                      </span>
                      {filtersHex !== "0" && (
                        <span
                          title={ReactDOMServer.renderToString(
                            <Translator
                              file="module-legalCompliance"
                              name="delete.filters"
                            />,
                          )}
                          className="btn btn-outline-danger ml-1"
                          onClick={() => goToInspection(0)}
                        >
                          <AppRemixIcon icon="delete-bin-6" />
                        </span>
                      )}
                    </div>
                    <AppMultiSelect
                      options={periodicityOptions}
                      title="Periodicidad"
                      value={values.periodicities}
                      onChange={(v) => setFieldValue("periodicities", v)}
                      hasSearchBox
                      hasSelectOptions
                    />
                    <AppMultiSelect
                      options={responsibleOptions}
                      title="Responsables"
                      value={values.responsibles}
                      onChange={(v) => setFieldValue("responsibles", v)}
                      hasSearchBox
                      hasSelectOptions
                    />
                    <AppMultiSelect
                      options={getEvaluationOptions()}
                      title="Última verificación"
                      value={values.latestEvaluation}
                      onChange={(v) => setFieldValue("latestEvaluation", v)}
                      hasSearchBox
                      hasSelectOptions
                    />
                  </>
                )}
              </Formik>
            )}
          </>
        )}
      </AuxSidebar>
    </>
  );
}
